module.exports = {
	"data": {
		"file": {
			"relativePath": "api/Ast_helper.Opn.html",
			"childRawHtml": {
				"content": "<div class=\"ocamldoc\">\n<div class=\"navbar\"><a class=\"pre\" href=\"Ast_helper.Mb.html\" title=\"Ast_helper.Mb\">Previous</a>\n&#xA0;<a class=\"up\" href=\"Ast_helper.html\" title=\"Ast_helper\">Up</a>\n&#xA0;<a class=\"post\" href=\"Ast_helper.Incl.html\" title=\"Ast_helper.Incl\">Next</a>\n</div>\n<h1>Module <a href=\"type_Ast_helper.Opn.html\">Ast_helper.Opn</a></h1>\n\n<pre><span class=\"keyword\">module</span> Opn: sig .. end</pre><hr width=\"100%\">\n\n<pre id=\"VALmk\">val mk : ?loc:Ast_helper.loc -&gt;       ?attrs:Ast_helper.attrs -&gt;       ?docs:Docstrings.docs -&gt;       ?override:Asttypes.override_flag -&gt;       Ast_helper.lid -&gt; Parsetree.open_description</pre></div>"
			}
		}
	},
	"pathContext": {
		"relativePath": "api/Ast_helper.Opn.html"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/api-ast-helper-opn-html.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/api-ast-helper-opn-html.json
// module chunks = 317